import React from 'react';
import '../Componentes/banner.css';

const BackgroundVideo = () => {
  return (
<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3950055.0510922987!2d-49.69453389273907!3d-14.798566988132144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1spt-BR!2sbr!4v1727377382392!5m2!1spt-BR!2sbr" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className='mapa-home'></iframe>

  );
}

export default BackgroundVideo;